import { createContext, useContext, useState, type ReactNode } from "react";
import type { Admin } from "../lib/types";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyActor = any;

type AdminContextValue = {
  isInstaller: boolean;
  admin: Admin | null;
  actor: AnyActor | null;
  setAdminAccess: (isInstaller: boolean, admin: Admin | null, actor: AnyActor) => void;
  clear: () => void;
};

const AdminContext = createContext<AdminContextValue | null>(null);

export function AdminProvider({ children }: { children: ReactNode }) {
  const [isInstaller, setIsInstaller] = useState(false);
  const [admin, setAdmin] = useState<Admin | null>(null);
  const [actor, setActor] = useState<AnyActor | null>(null);

  function setAdminAccess(installer: boolean, adminRecord: Admin | null, a: AnyActor) {
    setIsInstaller(installer);
    setAdmin(adminRecord);
    setActor(a);
  }

  function clear() {
    setIsInstaller(false);
    setAdmin(null);
    setActor(null);
  }

  return (
    <AdminContext.Provider value={{ isInstaller, admin, actor, setAdminAccess, clear }}>
      {children}
    </AdminContext.Provider>
  );
}

export function useAdmin(): AdminContextValue {
  const ctx = useContext(AdminContext);
  if (!ctx) throw new Error("useAdmin must be used within AdminProvider");
  return ctx;
}
